/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {GroupType} from './group-type';
import {Image} from './image';

export class EmGroup {
  id: number;
  name: string;
  description: string;
  type: GroupType;
  image: Image;
  uuid: string;
}
